import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { IContractInputBaseProps } from '../base/ContractInputBase';
import './ContractInputMain.scss';

interface IContractInputMainProps
  extends Omit<IContractInputBaseProps, 'name'> {}

const ContractInputMain = ({ id, ...props }: IContractInputMainProps) => {
  const { itemNameById } = useFormikContractHelpers();
  const { t } = useTranslation();

  return (
    <Contract.Input.Base
      {...props}
      id={id}
      name={`${itemNameById(id)}.content`}
      placeholder={t('input.placeholder.contract')}
      classNames={['contract-main-input']}
    />
  );
};

export default ContractInputMain;
